import { render, staticRenderFns } from "./SOCScreen4.vue?vue&type=template&id=49c81d40&"
import script from "./SOCScreen4.vue?vue&type=script&lang=js&"
export * from "./SOCScreen4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports